import { useNavigate } from 'react-router-dom'

import { Dialog } from '@factorialco/f0-react/dist/experimental'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'
import { joinAsSentence } from 'modules/core/lib/stringUtils'

interface Props {
  onClose: () => void
  missingFields: string[]
  id: number
}
export const JobPostingMissingFieldsDialog = ({ onClose, missingFields, id }: Props) => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()

  const onClickEdit = () => {
    onClose()

    navigate(
      `${navigation.ats.jobs.jobsId.settings.fullPath({
        jobId: id,
      })}?section=description`
    )
  }

  return (
    <Dialog
      open
      onClose={onClose}
      header={{
        type: 'warning',
        title: i18n.t('ats.job_details.job_posting_missing_fields_dialog.title'),
        description: i18n.t('ats.job_details.job_posting_missing_fields_dialog.description', {
          missing_fields: joinAsSentence(missingFields),
        }),
      }}
      actions={{
        primary: {
          label: i18n.t('common.edit'),
          onClick: onClickEdit,
        },
        secondary: {
          label: i18n.t('common.cancel'),
          onClick: onClose,
        },
      }}
    />
  )
}
